<template>
  <!-- Container for the order summary box with padding -->
  <div>
    <v-form v-if="isUser" ref="userCouponCodeForm" @submit.prevent>
      <template v-if="isCouponLoading">
        <GiftCardSkeleton />
      </template>

      <template v-else>
        <v-row class="">
          <v-col cols="8" sm="9" class="pb-0">
            <v-text-field
              type="text"
              density="compact"
              placeholder="Discount Code"
              v-model="userDiscountTextCode"
              variant=""
              class="text-black coupon-field-input focus-effect"
              @blur.prevent="resetUserCouponCodeForm"
              :rules="requiredRules"
              color="primary"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="3" class="pb-20 pl-0">
            <v-btn
              block
              class="rounded text-uppercase bg-secondryButton text-white fontsize-14 checkout-product-button-height cart-products-button checkout-page-btn"
              size="large"
              density="comfortable"
              :rounded="0"
              :variant="isHovering ? 'outlined' : ''"
              v-bind="props"
              :disabled="isCheckoutProcessing"
              @click.prevent="handleUserApplyClick"
              >APPLY</v-btn
            >
          </v-col>
        </v-row>

        <v-row
          v-for="(item, index) in userDiscountCodeList"
          :key="index"
          class="align-center"
        >
          <v-col cols="6" md="8">
            <h3>{{ item }}</h3>
          </v-col>
          <v-col class="text-end" cols="6" md="4">
            <a
              href="#"
              class="text-black text-decoration-underline"
              @click.prevent="handleUserCancelClick(item)"
            >
              Remove Coupon
            </a>
          </v-col>
        </v-row>
      </template>
    </v-form>

    <!-- :rules="requiredRules" -->
    <!-- :readonly="readOnlyCheckBox" -->
    <!-- @blur.prevent="resetGuestCouponCodeForm" -->
    <!-- discountGuestCode:{{ discountGuestCode }} guestCouponCode:{{
            guestCouponCode
          }}  isCouponLoading-->

    <v-form ref="guestCouponCodeForm" @submit.prevent v-else>
      <template v-if="isCouponLoading">
        <v-row class="align-center" style="height: 60px">
          <v-col cols="10" class="">
            <v-skeleton-loader
              class="checkout-page-text-field"
              color="transparent"
              type="text"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-skeleton-loader
              class="checkout-page-text-field checkout-page-guest-btn"
              color="transparent"
              type="button"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row no-gutters>
          <v-col cols="9">
            <v-text-field
              type="text"
              density="compact"
              placeholder="Discount Code"
              v-model="guestCouponCode"
              variant=""
              class="text-black coupon-field-input focus-effect"
              @blur.prevent="resetGuestCouponCodeForm"
              :rules="requiredRules"
              :rounded="1"
              color="primary"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="pl-2">
            <v-btn
              v-if="!discountGuestCode"
              block
              class="rounded text-uppercase checkout-page-btn bg-secondryButton text-white fontsize-14 checkout-product-button-height cart-products-button"
              size="large"
              density="comfortable"
              :rounded="0"
              :disabled="isCheckoutProcessing"
              @click.prevent="handleGuestApplyClick"
              >APPLY</v-btn
            >
            <v-btn
              v-if="discountGuestCode"
              block
              class="rounded text-uppercase bg-red text-white fontsize-14 checkout-product-button-height cart-products-button"
              size="large"
              density="comfortable"
              :rounded="0"
              :disabled="isCheckoutProcessing"
              @click.prevent="handleGuestCancelClick"
              >CANCEL</v-btn
            >
          </v-col>
        </v-row>
      </template>
    </v-form>
  </div>
</template>

<script>
const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;
import GiftCardSkeleton from "./GiftCardSkeleton.vue";

export default {
  name: "CouponCode", // Name of the component for Vue
  props: [
    "discountGuestCode",
    "isCouponLoading",
    "isUser",
    "userDiscountCodeList",
    "isCheckoutProcessing",
  ],
  components: {
    GiftCardSkeleton,
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      guestCouponCode: this.discountGuestCode,
      userDiscountTextCode: "",
    };
  },

  watch: {
    discountGuestCode(newValue, oldValue) {
      this.guestCouponCode = newValue;
      if (!newValue && oldValue) {
        this.$nextTick(() => this.$refs.guestCouponCodeForm?.reset());
      }
    },
    userDiscountCodeList() {
      this.userDiscountTextCode = null;
    },
  },
  methods: {
    async handleGuestApplyClick() {
      let validate = await this.$refs.guestCouponCodeForm.validate();
      if (validate && validate.valid) {
        this.$emit("checkGuestCouponCode", this.guestCouponCode);
      }
    },
    handleGuestCancelClick() {
      this.$emit("removeGuestCouponCode", this.guestCouponCode);
    },
    resetGuestCouponCodeForm() {
      if (!this.guestCouponCode && this.$refs.guestCouponCodeForm) {
        this.$refs.guestCouponCodeForm.reset();
      }
    },
    resetUserCouponCodeForm() {
      if (!this.userDiscountTextCode && this.$refs.userCouponCodeForm) {
        this.$refs.userCouponCodeForm.reset();
      }
    },
    async handleUserApplyClick() {
      let validate = await this.$refs.userCouponCodeForm.validate();
      if (validate && validate.valid) {
        this.$emit("checkUserCouponCode", this.userDiscountTextCode);
      }
    },
    handleUserCancelClick(item) {
      this.$emit("removeUserCouponCode", item);
    },
  },
  async created() {},
};
</script>
<style lang="scss">
@media (max-width: 390px) {
  .v-field__input {
    font-size: 12px !important;
  }
}

.v-input__details {
  padding-top: 0px;
}

.pb-20 {
  padding-bottom: 20px !important;
}

.chekout-page-image-skeleton .v-skeleton-loader__image {
  height: 60px;
}

.checkout-page-text-field .v-skeleton-loader__text {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 12px;
  margin-left: 0px;
}

.checkout-page-carts-text-field .v-skeleton-loader__text {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 4px;
}

.checkout-page-btn .v-skeleton-loader__button {
  margin-right: 0px;
  margin-top: 0px;
}

.checkout-page-guest-btn .v-skeleton-loader__button {
  margin-right: 0px;
  margin-top: 0px;
  margin-left: 0px;
}

// start.... below code for making textfield just like stripe textfield.
.coupon-field-input .v-field__input {
  border: 1px solid #e6e6e6;
  background-color: #fff;
  border-radius: 5px;
  padding: 12px;
  height: 45px;
}

.focus-effect .v-field__input {
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.focus-effect .v-field__input:focus-within {
  border-color: #0f162a;
  box-shadow: 0px 0px 0px 3px #ccd3e0;
}

.coupon-field-input .v-field__input::placeholder {
  color: #858383;
  opacity: 1;
}

.coupon-field-input .v-field--error .v-field__input {
  border: 2px solid #df1b41 !important;
  border-color: #df1b41 !important;
}

.focus-effect .v-field--error .v-field__input:focus-within {
  border-color: #df1b41 !important;

  box-shadow: 0px 0px 0px 3px #fafafa !important;
}

.coupon-field-input .v-input__details {
  padding-left: 0px;
}
.coupon-field-input .v-messages__message {
  font-size: 14px;
  color: #df1b41;
}
// end....
</style>
